module.exports = __webpack_public_path__ + "img/louq-round.1f0c326a.png";